import { render, staticRenderFns } from "./upload_excel.vue?vue&type=template&id=1b31d79c&scoped=true&"
import script from "./upload_excel.vue?vue&type=script&lang=ts&"
export * from "./upload_excel.vue?vue&type=script&lang=ts&"
import style0 from "./upload_excel.vue?vue&type=style&index=0&id=1b31d79c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b31d79c",
  null
  
)

export default component.exports